"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PlanSelection = void 0;

var _styles = require("./styles");

var _index = require("../../atoms/GeneralTextBox/index");

var _jsxRuntime = require("react/jsx-runtime");

var PlanSelection = function PlanSelection(_ref) {
  var planSelection = _ref.planSelection,
      setbuttonActive = _ref.setbuttonActive;

  var setActivePlan = function setActivePlan(e) {
    var buttonsPlan = document.querySelectorAll(".button-plan");
    buttonsPlan.forEach(function (button) {
      return button.classList.remove("active");
    });
    e.target.closest(".button-plan").classList.add("active");
    setbuttonActive(true);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_styles.Container, {
    children: planSelection === null || planSelection === void 0 ? void 0 : planSelection.map(function (plan, index) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_index.GeneralTextBox, {
        className: "button-plan",
        onClick: function onClick(e) {
          return setActivePlan(e);
        },
        number: plan === null || plan === void 0 ? void 0 : plan.number,
        name: plan === null || plan === void 0 ? void 0 : plan.name
      }, index);
    })
  });
};

exports.PlanSelection = PlanSelection;